import { Calendar } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import clsx from "clsx";
import { useRole } from "contexts/RoleContext";
import {
  HomeIcon,
  CourseIcon,
  CardIcon,
  SettingsIcon,
  StudentsIcon,
} from "constants/sidebar_icons";

const studentItems = [
  { icon: HomeIcon, label: "Home", path: "/dashboard" },
  { icon: CourseIcon, label: "Courses", path: "/my-courses" },
  { icon: CardIcon, label: "Pricing", path: "/pricing" },
  { icon: () => <Calendar size={20} />, label: "Calendar", path: "/my-calendar" },
  { icon: SettingsIcon, label: "Settings", path: "/settings" },
];

const tutorItems = [
  { icon: HomeIcon, label: "Home", path: "/tutor/dashboard" },
  { icon: CourseIcon, label: "Courses", path: "/tutor/my-courses" },
  { icon: StudentsIcon, label: "Students", path: "/tutor/my-students" },
  { icon: () => <Calendar size={20} />, label: "Calendar", path: "/tutor/my-calendar" },
  { icon: SettingsIcon, label: "Settings", path: "/settings" },
];

export default function MobileNav() {
  const { role } = useRole();
  const { pathname } = useLocation();
  const items = role === "tutor" ? tutorItems : studentItems;

  const isActive = (path) => {
    if (path === "/dashboard" || path === "/tutor/dashboard") {
      return pathname === "/" || pathname === "/dashboard" || pathname === "/tutor/dashboard";
    }
    if (path === "/settings") return pathname.startsWith("/settings");
    return pathname === path || pathname.startsWith(path + "/");
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-neutral_stroke_2 md:hidden safe-area-bottom">
      <ul className="flex items-center justify-around px-1 py-2">
        {items.map(({ icon: Icon, label, path }) => {
          const active = isActive(path);
          return (
            <li key={path}>
              <Link
                to={path}
                className="flex flex-col items-center gap-[3px] px-2 py-1 min-w-[48px]"
              >
                <span className={clsx(active ? "text-brand_secondary" : "text-border_stroke_2")}>
                  <Icon size={22} />
                </span>
                <span
                  className={clsx(
                    "text-[10px] leading-tight",
                    active ? "font-aileron_sb text-brand_secondary" : "font-aileron_r text-border_stroke_2"
                  )}
                >
                  {label}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
